import React from 'react';

import { otherLinks } from './data.js';

const YoutubeSection = () => (
  <section className="section section--gray section--spacer">
    <div className="container">
      <div className="row">
        <div className="col-12">
          <h2 className="text-uppercase text-center section-header mb-5">#HoneyGuide</h2>
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <div className="video-player">
            <div className="video-player-content">
              <iframe
                title="Youtube"
                src={otherLinks.youtubeUrl}
                allow="encrypted-media"
                allowFullScreen
                width="100%"
                height="100%"
                frameBorder={0}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default YoutubeSection;



// WEBPACK FOOTER //
// ./src/screens/Landing/YoutubeSection.jsx